module.exports = __webpack_public_path__ + "static/img/logo.1980d85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/public/logo.png
// module id = T9Cf
// module chunks = 3